export const HOUR_VIEW_KEYS = ['All', 'Regular', 'OT', 'DT'];

export function showRegularHours(view) {
  return view === 'All' || view === 'Regular';
}

export function showOTHours(view) {
  return view === 'All' || view === 'OT';
}

export function showDoubleOTHours(view) {
  return view === 'All' || view === 'DT';
}

export function isSingleHourTypeView(view) {
  return view !== 'All';
}
